/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../buttons/Button';
// import Text from '../typography/Text';
import Title from '../typography/Title';

import styles from '../../../styles/cards/film.module.css';

const propTypes = {
    item: PropTypes.shape({}),
    wide: PropTypes.bool,
    withFavorite: PropTypes.bool,
    withContents: PropTypes.bool,
    className: PropTypes.string,
};

function FilmCard({ item = null, wide = null, className = null, ...props }) {
    const { title = null, year = null, duration = null, url = null, credits = null } = item || {};

    const directors = useMemo(
        () =>
            (credits || [])
                .filter(
                    ({ roles = [] }) =>
                        (roles || []).map((role) => role.handle).indexOf('director') !== -1,
                )
                .map(({ person = null }) => person?.name)
                .join(', ') || null,
        [credits],
    );

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [styles.wide]: wide !== null,
                    [className]: className !== null,
                },
            ])}
            href={url}
            {...props}
        >
            <div className={styles.content}>
                <Title className={styles.title} size="large">
                    {title}
                </Title>
                <Title className={styles.description} size="medium">
                    {directors !== null ? (
                        <>
                            {directors}
                            {' — '}
                        </>
                    ) : null}
                    {year}
                    {' — '}
                    <FormattedMessage
                        defaultMessage="{duration} min"
                        description="Film label"
                        values={{ duration }}
                    />
                </Title>
            </div>
        </Button>
    );
}

FilmCard.propTypes = propTypes;

export default FilmCard;
